import React from 'react';
import { useTranslation } from 'react-i18next';

const Epvpd = () => {
  const { t } = useTranslation("help");

  return (
    <div style={styles.container}>
      {/* Title */}
      <h2 style={styles.title}>{t("epvpd.title", "Vulnerable Prompt and Docs")}</h2>

      {/* Section (a) - Purpose & Endpoint */}
      <div style={styles.section}>
        <span style={styles.sectionLabel}>(a)</span>
        <div style={styles.sectionContent}>
          <p style={styles.paragraph}>
            <strong style={styles.strongText}>{t("epvpd.purposeLabel", "Purpose:-")}</strong> {t("epvpd.purposeText", "This simulator endpoint allows Prompts & Docs WhiteHaX tester to test Malicious Prompts & Docs aginast a vulnarable endpoint.")}
          </p>
          <p style={styles.paragraph}>
            <strong style={styles.strongText}>{t("epvpd.endpointUrlLabel", "Target URL:")}</strong>
          </p>
          <div style={styles.urlContainer}>
            <a 
              href="http://54.177.207.48:8000/chat" 
              style={styles.link} 
              target="_blank" 
              rel="noopener noreferrer"
            >
              http://54.177.207.48:8000/chat
            </a>
          </div>
        </div>
      </div>

      {/* Section (b) - Request Json */}
      <div style={styles.section}>
        <span style={styles.sectionLabel}>(b)</span>
        <div style={styles.sectionContent}>
          <p style={styles.paragraph}>
            <strong style={styles.strongText}>{t("epvpd.requestJsonLabel", "Request Json:-")}</strong> {t("epvpd.requestJsonDesc1", "This is the Request JSON template to send test prompts & malicious docs to the Secure Simulator Target. Configure headers, body, prompt insertion path, and data type & follow Notes in the")}
          </p>
          <p style={styles.paragraph}>
            {t("epvpd.requestJsonDesc2", "The simulator accepts an application/json body. AUTH_KEY is required inside request_template and must match an authorized key. The target validates it on every request and returns HTTP 401 when it is missing or invalid.")}
          </p>

          {/* Request JSON Code Block */}
          <div style={styles.codeBlock}>
            <div>{'{'}</div>
            <div style={styles.indent1}>
              <span style={styles.jsonKey}>"headers"</span>: {'{'}
            </div>
            <div style={styles.indent2}>
              <span style={styles.jsonKey}>"Content-Type"</span>: <span style={styles.jsonString}>"application/json"</span>
            </div>
            <div style={styles.indent1}>{'}'},</div>
            <div style={styles.indent1}>
              <span style={styles.jsonKey}>"data_type"</span>: <span style={styles.jsonString}>"json"</span>,
            </div>
            <div style={styles.indent1}>
              <span style={styles.jsonKey}>"request_template"</span>: {'{'}
            </div>
            <div style={styles.indent2}>
              <span style={styles.jsonKey}>"AUTH_KEY"</span>: <span style={styles.jsonString}>"&lt;authorized-key&gt;"</span>,
            </div>
            <div style={styles.indent2}>
              <span style={styles.jsonKey}>"message"</span>: <span style={styles.jsonString}>"{"{{PROMPT}}"}"</span>
            </div>
            <div style={styles.indent1}>{'}'},</div>
            <div style={styles.indent1}>
              <span style={styles.jsonKey}>"prompt_path"</span>: <span style={styles.jsonString}>"message"</span>
            </div>
            <div>{'}'}</div>
          </div>
        </div>
      </div>

      {/* Section (C) - Response Json */}
      <div style={styles.section}>
        <span style={styles.sectionLabel}>(C)</span>
        <div style={styles.sectionContent}>
          <p style={styles.paragraph}>
            <strong style={styles.strongText}>{t("epvpd.responseJsonLabel", "Response Json:-")}</strong> {t("epvpd.responseJsonDesc", "Template that tells WhiteHaX where the model output lives ,It maps the actual response body field that contains the answer.")}
          </p>

          {/* Response JSON Code Block */}
          <div style={styles.codeBlock}>
            <div>{'{'}</div>
            <div style={styles.indent1}>
              <span style={styles.jsonKey}>"response"</span>: <span style={styles.jsonString}>"{"{{RESP}}"}"</span>,
            </div>
            <div style={styles.indent1}>
              <span style={styles.jsonKey}>"status"</span>: <span style={styles.jsonString}>"ok"</span>
            </div>
            <div>{'}'}</div>
          </div>
        </div>
      </div>

      {/* Section (D) - Expected Test Results */}
      <div style={styles.section}>
        <span style={styles.sectionLabel}>(D)</span>
        <div style={styles.sectionContent}>
          <p style={styles.paragraph}>
            <strong style={styles.strongText}>{t("epvpd.expectedResultsLabel", "Expected Test Results against this simulator:-")}</strong> {t("epvpd.expectedResultsText", "For a vulnerable simulator, the expected readiness result scores should be close to 0% across all categories, indicating that malicious prompts or documents are not being blocked effectively.")}
          </p>
        </div>
      </div>
    </div>
  );
};

// Component Styles (Dark Theme)
const styles = {
  container: {
    maxWidth: '850px',
    margin: '0 auto',
    padding: '24px',
    color: '#e0e0e0',
    backgroundColor: '#181a1f',
    borderRadius: '8px',
    fontFamily: 'Segoe UI, Roboto, sans-serif'
  },
  title: {
    margin: '0 0 20px 0',
    fontWeight: 'bold',
    color: '#ffffff',
    fontSize: '20px'
  },
  section: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '20px'
  },
  sectionLabel: {
    width: '32px',
    flexShrink: 0,
    fontWeight: 'bold',
    color: '#a0a0a0'
  },
  sectionContent: {
    flexGrow: 1
  },
  paragraph: {
    margin: '0 0 10px 0',
    lineHeight: '1.6',
    color: '#cccccc',
    fontSize: '14px'
  },
  strongText: {
    color: '#ffffff'
  },
  urlContainer: {
    margin: '5px 0 15px 0'
  },
  link: {
    color: '#4fa3d1',
    textDecoration: 'underline'
  },
  codeBlock: {
    backgroundColor: '#0d0e11',
    color: '#e0e0e0',
    padding: '16px 20px',
    margin: '12px 0',
    borderRadius: '6px',
    border: '1px solid #2a2d34',
    fontFamily: 'Consolas, Monaco, "Andale Mono", monospace',
    fontSize: '13px',
    lineHeight: '1.5',
    overflowX: 'auto',
    whiteSpace: 'pre'
  },
  indent1: {
    paddingLeft: '20px'
  },
  indent2: {
    paddingLeft: '40px'
  },
  jsonKey: {
    color: '#6fc2ef'
  },
  jsonString: {
    color: '#e59373'
  }
};

export default Epvpd;